import {
  ForgeButton,
  ForgeDialog,
  ForgeIcon,
  ForgeIconButton,
  ForgeScaffold,
  ForgeToolbar,
} from '@tylertech/forge-react';
import React, { useRef } from 'react';
import './index.scss';
import { useEscapeKey } from 'common/visualizations/views/agGridReact/customHooks/useEscapeKey';
import { IDialogBeforeCloseEventData } from '@tylertech/forge';
import EventBus from 'common/visualizations/views/agGridReact/helpers/EventBus';
import { I18n } from 'common/i18n';

interface AdvancedTotalingModalProps {
  isTableAdvancedTotalingModalOpen: boolean;
  activeAdvancedTotalingModalTitle: string;
}

const scope = 'shared.components.advanced_totaling.modal';

const AdvancedTotalingModal: React.FC<AdvancedTotalingModalProps> = ({
  isTableAdvancedTotalingModalOpen,
  activeAdvancedTotalingModalTitle,
}: AdvancedTotalingModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const hideModal = () => {
    EventBus.dispatch('advancedTotaling', {
      activeAdvancedTotalingModalTitle: '',
      isTableAdvancedTotalingModalOpen: false,
    });
  };

  useEscapeKey({
    onKeyup: hideModal,
    enabled: isTableAdvancedTotalingModalOpen,
    eventTarget: modalRef.current || document,
    restoreFocusTarget: '.authoring-modal',
  });

  return (
    <ForgeDialog
      on-forge-dialog-before-close={(e: CustomEvent<IDialogBeforeCloseEventData>) => {
        if (e.detail.reason === 'backdrop') {
          e.preventDefault();
        }
      }}
      on-forge-dialog-close={hideModal}
      open={isTableAdvancedTotalingModalOpen}
      persistent={true}
      ref={modalRef}
      className="advanced-totaling-dialog"
      data-testid="advanced-totaling-dialog"
    >
      <div className={'advanced-totaling-modal'} data-testid="advanced-totaling-modal">
        <ForgeScaffold>
          <ForgeToolbar slot={'header'}>
            <div slot="start" className="modal-title-container">
              <h1 className="forge-typography--heading4" data-testid="advanced-totaling-modal-title">
                {`${I18n.t('title', { scope })} - ${activeAdvancedTotalingModalTitle}`}
              </h1>
            </div>
            <ForgeIconButton slot={'end'} onClick={hideModal} data-testid="close-btn">
              <ForgeIcon name={'close'}></ForgeIcon>
            </ForgeIconButton>
          </ForgeToolbar>
          <div className="advanced-totaling-modal-body" slot="body"></div>
          <ForgeToolbar slot={'footer'}>
            <ForgeButton slot={'start'} disabled={true} data-testid="clear-all-formulas-btn">
              <ForgeIcon name={'delete'}></ForgeIcon>
              {I18n.t('clear_all_formulas', { scope })}
            </ForgeButton>
            <ForgeButton slot={'end'} variant={'raised'} data-testid="apply-btn">
              {I18n.t('apply', { scope })}
            </ForgeButton>
          </ForgeToolbar>
        </ForgeScaffold>
      </div>
    </ForgeDialog>
  );
};

export default AdvancedTotalingModal;
